// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_1WwYmvlKZ2XX5tRjQppGm5"};